<template>
  <div>
    <nav id="navigation" class="navbar navbar-expand-lg navbar-light">
      <div class="container full p-lg-0">
        <router-link class="navbar-brand w-50" to="/">
          <LogoSvg />
          <span class="d-sm-inline">FİKİR PLATFORMU</span>
        </router-link>
        <div
          class="doin-icon doin-button-mobile"
          @click="isDoinWallet = !isDoinWallet"
        >
          <img src="../../assets/images/FikirCoin.png" class="doin-img" />
          <span
            class="nav navbar-nav ml-auto align-items-center justify-content-center font-weight-bold doin-point"
          >
            {{ totalPoints }}
          </span>
        </div>
        <button
          @click="isNavbarToggler = !isNavbarToggler"
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarToggler"
          aria-controls="navbarToggler"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse w-100">
          <div
            id="search"
            class="navbar-nav w-50 justify-content-left"
          >
          <div v-if="isDashboardVisible">
              <a :href="dashboardUrl" class="btn bg-orange text-white"
                >Dashboard</a
              >
            </div>
          </div>
          <div class="doin-icon doin-button"
              @click="isDoinWallet = !isDoinWallet">
            <img
              src="../../assets/images/FikirCoin.png"
              class="doin-img"
            />
            <span
              class="nav navbar-nav ml-auto align-items-center justify-content-center font-weight-bold doin-point"
            >
              {{ totalPoints }}
              <br>
              Cüzdanım
            </span>
          </div>
          <ul
            class="nav navbar-nav ml-auto w-100 align-items-center justify-content-end"
          >
            <li class="nav-item font-weight-bold">
              <router-link class="nav-link" to="/FrequentlyAskedQuestion">
                SSS
              </router-link>
            </li>
            <li class="nav-item font-weight-bold">
              <router-link class="nav-link" to="/suggestion/idea">
                Fikirlerim
              </router-link>
            </li>
            <b-dropdown
              style="margin-left: 10px"
              id="navbarDropdown"
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template slot="button-content">
                <span
                  class="font-weight-bold"
                  :title="user ? user.Data.FullName : ''"
                >
                  {{ user ? user.Data.FullName : "" }}
                </span>
                <img
                  v-if="user.Data.UserProfileImage"
                  class="user-image fallback-image"
                  :src="
                    user.Data.UserProfileImage
                      ? `data:image/png;base64, ${user.Data.UserProfileImage}`
                      : ''
                  "
                  :alt="user.Data.FullName | getInitialsFilter"
                />
                <i
                  v-else
                  class="user-image fallback-image"
                  :alt="user.Data.FullName | getInitialsFilter"
                  >{{ user.Data.FullName | getInitialsFilter }}</i
                >
              </template>
              <b-dropdown-item
                v-if="user.Data.IsVisibleAdminPanel"
                @click="$router.push('/admin/suggestions')"
                >Değerlendirme Ekranı</b-dropdown-item
              >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="logout">Çıkış Yap</b-dropdown-item>
            </b-dropdown>
          </ul>
        </div>
      </div>
    </nav>
    <transition name="slide-down">
      <div
        v-if="isNavbarToggler"
        class="navbar container mw-100 navbar-collapse collapse d-lg-none pb-3"
        :class="{ show: isNavbarToggler }"
        id="navbarToggler"
      >
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
          <li class="nav-item active">
            <router-link class="nav-link" to="/FrequentlyAskedQuestion">
              Sıkça Sorulan Sorular
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/suggestion/idea">
              Fikirlerim
            </router-link>
          </li>
          <b-dropdown
            id="navbarDropdown"
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template slot="button-content">
              <span :title="user ? user.Data.FullName : ''">
                {{ user ? user.Data.FullName : "" }}
              </span>
              <img
                v-if="user.Data.UserProfileImage"
                class="article-user-img fallback-image"
                :src="
                  user.Data.UserProfileImage
                    ? `data:image/png;base64, ${user.Data.UserProfileImage}`
                    : ''
                "
                :alt="user.Data.FullName | getInitialsFilter"
              />
              <i
                v-else
                class="user-image fallback-image"
                :alt="user.Data.FullName | getInitialsFilter"
                >{{ user.Data.FullName | getInitialsFilter }}</i
              >
            </template>
            <b-dropdown-item
              v-if="user.Data.IsVisibleAdminPanel"
              @click="$router.push('/admin/suggestions')"
              >Değerlendirme Ekranı</b-dropdown-item
            >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="logout">Çıkış Yap</b-dropdown-item>
          </b-dropdown>
        </ul>
      </div>
    </transition>
    <transition name="fade">
      <DoinWallet
        v-if="isDoinWallet"
        :columns="columns"
        :totalPoints="totalPoints"
        @close="isDoinWallet = $event"
        :doinWallets="doinWallets"
        :isWalletSeasonActive="isWalletSeasonActive"
        :walletUrl="walletUrl"
        :tlValue="tlValue"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LogoSvg from "../Main/LogoSvg.vue";
import { getInitials } from "../../helpers";
import { suggestionService } from "../../services";
import DoinWallet from "./Cards/Modals/DoinWallet.vue";
export default {
  name: "MainHeader",
  components: {
    LogoSvg,
    DoinWallet,
  },
  data() {
    return {
      isNavbarToggler: false,
      searchText: "",
      totalPoints: 0,
      doinWallets: [],
      isDoinWallet: false,
      isWalletSeasonActive: false,
      tlValue: 0,
      walletUrl: "",
      columns: [
        {
          label: "Toplam Coin",
          field: "Point",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
          width: "100px",
        },
        {
          label: "Harcanan Coin",
          field: "SpentPoint",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
          width: "100px",
        },
        {
          label: "Kalan Coin",
          field: "RemainingPoint",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Kalan Coin Değeri TL",
          field: "CashValue",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
          width: "150px",
        },
        {
          label: "Harcama Tarihi",
          field: "SpentDate",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
      ],
      dashboardUrl: process.env.VUE_APP_DASHBOARD_URL, // Use environment variable
      isDashboardVisible: false
    };
  },
  filters: {
    getInitialsFilter(value) {
      return getInitials(value);
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
  },
  created() {
    this.getSuggestionTotalPoints(this.user.Data.UserId);
    this.getDoinWalletByCustomerId(this.user.Data.UserId);
    this.getDoinWalletSettings();
    this.isDashboardVisible = this.user.Data.CompanyId == 2;//Doğuş Otomotiv için dashboard görünür olacak
  },
  methods: {
    handleSearch() {
      if (this.searchText && this.searchText.trim().length > 0)
      {
        this.$router.push({
          path: '/search',
          query: { searchText: this.searchText }
        });
      }
    },
    delete_cookie(name) {
      document.cookie =
        name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    },
    async logout() {
      localStorage.clear();
      this.delete_cookie("token");
      await this.$msalInstance
        .logoutRedirect({})
        .then(() => {})
        .catch(() => {});
      location.reload();
    },
    async getSuggestionTotalPoints(createdUserId) {
      try {
        const res = await suggestionService.fetchGetSuggestionTotalPoints(
          createdUserId
        );
        this.totalPoints = res;
      } catch (error) {
        //console.log(error);
      }
    },
    async getDoinWalletByCustomerId(customerId) {
      try {
        const res = await suggestionService.fetchGetDoinWalletByCustomerId(
          customerId
        );

        this.doinWallets = res;
      } catch (error) {
        //console.log(error);
      }
    },
    async getDoinWalletSettings() {
      try {
        const res = await suggestionService.fetchDoinWalletSettings();
        this.isWalletSeasonActive = res.IsActiveSeason;
        this.tlValue = res.TLValue;
        this.walletUrl = res.WalletUrl;
      } catch (error) {
        //console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/scss/header.scss";
</style>
